import { render, staticRenderFns } from "./CategoryTile.vue?vue&type=template&id=2414f836&"
import script from "./CategoryTile.vue?vue&type=script&lang=js&"
export * from "./CategoryTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports